import { RedirectOutbound } from '@modusign/design-system';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';

import { useUrlQuery } from '@hooks';

import DocumentFormDownloadPageRedirectionGAEventRecord from '@app/containers/DocumentFormDownloadPageRedirectionGAEventRecord';
import { isAuthenticated } from '@app/store/account/selectors';

interface AuthLayoutProps {
  children: ReactNode;
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  const isAuth = useSelector(isAuthenticated);
  const query = useUrlQuery();
  const redirectTo = query.get('redirectTo');

  if (!isAuth) {
    return children;
  }

  if (redirectTo) {
    const decodedRedirectionUrl = window.decodeURIComponent(redirectTo);
    /**
     * 내부, 외부 페이지로 이동하는 주소인지 판단 후 알맞은 리다이렉션 컴포넌트 렌더링
     */
    if (redirectTo.startsWith('/')) {
      return <Redirect to={decodedRedirectionUrl} />;
    }
    return (
      <>
        <DocumentFormDownloadPageRedirectionGAEventRecord />
        <RedirectOutbound to={decodedRedirectionUrl} />;
      </>
    );
  }
  return <Redirect to="/" />;
}
